import React, { useState, useEffect } from 'react';
import './Home.css';

import photo1 from '../assets/photo1.png';

export default function Home() {
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const updateCountdown = () => {
      const weddingDate = new Date('2026-08-01T00:00:00').getTime();
      const now = new Date().getTime();
      const distance = weddingDate - now;

      if (distance > 0) {
        setCountdown({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      }
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="home">
      <section className="hero">
        <div className="hero__inner">
          <div className="hero__circle-wrap">
            <div className="hero__save-tag">
              <span className="hero__save-tag-vertical">AYO·AYO</span>
              <span className="hero__save-tag-small">SAVE THE DATE</span>
            </div>

            <div className="hero__circle">
              <span className="hero__confetti hero__confetti--1" />
              <span className="hero__confetti hero__confetti--2" />
              <span className="hero__confetti hero__confetti--3" />
              <span className="hero__confetti hero__confetti--4" />
              <span className="hero__confetti hero__confetti--5" />
              <span className="hero__confetti hero__confetti--6" />

              <div className="hero__circle-content">
                <h1 className="hero__name hero__name--first">Ayotomide</h1>

                <div className="hero__and-wrap">
                  <span className="hero__and">- AND -</span>
                </div>

                <h1 className="hero__name hero__name--second">Ayobami</h1>

                <div className="hero__date-row">
                  <span className="hero__date-part">August</span>
                  <span className="hero__date-divider" />
                  <span className="hero__date-day">01</span>
                  <span className="hero__date-divider" />
                  <span className="hero__date-part">2026</span>
                </div>
              </div>
            </div>
          </div>

          <div className="hero__photo">
            <img src={photo1} alt="Ayotomide and Ayobami" />
          </div>
        </div>
      </section>

      <section className="countdown">
        <p className="countdown__heading">The celebration begins in</p>

        <div className="countdown__timer">
          <div className="countdown__item">
            <span className="countdown__num">{countdown.days}</span>
            <span className="countdown__label">Days</span>
          </div>
          <div className="countdown__item">
            <span className="countdown__num">{countdown.hours}</span>
            <span className="countdown__label">Hours</span>
          </div>
          <div className="countdown__item">
            <span className="countdown__num">{countdown.minutes}</span>
            <span className="countdown__label">Minutes</span>
          </div>
          <div className="countdown__item">
            <span className="countdown__num">{countdown.seconds}</span>
            <span className="countdown__label">Seconds</span>
          </div>
        </div>
      </section>
    </div>
  );
}